exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-no-link[data-v-0e190793]{cursor:pointer}", ""]);

// exports
